/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Features_Credits_DescriptionInputs */

const en_landing_features_credits_description = /** @type {(inputs: Landing_Features_Credits_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIFO consumption, expiration, auto-grant on signup, and revocation — ready for usage-based billing.`)
};

const zh_landing_features_credits_description = /** @type {(inputs: Landing_Features_Credits_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIFO 消费、过期控制、注册自动发放和撤销 — 为按量计费做好准备。`)
};

/**
* | output |
* | --- |
* | "FIFO consumption, expiration, auto-grant on signup, and revocation — ready for usage-based billing." |
*
* @param {Landing_Features_Credits_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_features_credits_description = /** @type {((inputs?: Landing_Features_Credits_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Features_Credits_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_features_credits_description(inputs)
	return zh_landing_features_credits_description(inputs)
});
export { landing_features_credits_description as "landing.features.credits.description" }